import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const NewTenderPageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: '100%',
  alignItems: "center",
  backgroundColor: theme.palette.jigsaw.white,
}));

export const InputsContainer = styled(Box)(() => ({}));

export const Header = styled(Box)(({ theme }) => ({
  fontFamily: 'Roboto',
  fontWeight: 700,
  fontSize: '42px',
  lineHeight: '110%',
  letterSpacing: '0%',
  textAlign: 'center',
  color: theme.palette.jigsaw.header,
  padding: "30px",
}));

export const SubHeader = styled(Box)(({ theme }) => ({
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '140%',
  letterSpacing: '0%',
  textAlign: 'center',
  color: theme.palette.jigsaw.header,
  padding: "5px",
  marginBottom: "35px",
}));

export const InitializeButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'disabled',
})(({ theme, disabled }) => ({
  width: "157px",
  height: "48px",
  padding: "16px 12px",
  borderRadius: "5px",
  borderWidth: "2px",
  borderStyle: "solid",
  borderColor: disabled ? theme.palette.grey[400] : theme.palette.jigsaw.blue,
  backgroundColor: disabled ? theme.palette.grey[300] : theme.palette.jigsaw.blue,
  color: disabled ? theme.palette.grey[600] : "#FFFFFF",
  fontSize: "16px",
  fontWeight: "bold",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: disabled ? "not-allowed" : "pointer",
  transition: "all 0.3s ease",
  marginTop: "35px",
  pointerEvents: disabled ? "none" : "auto",

  "&:hover": {
    backgroundColor: disabled ? theme.palette.grey[300] : theme.palette.jigsaw.darkBlue,
  },
}));